// extracted by mini-css-extract-plugin
export var alignCenter = "_77-d";
export var bannerShown = "_77-6";
export var buttonContent = "_77-0";
export var cardList = "_77-1";
export var centerContent = "_77-2";
export var chevron = "_77-3";
export var closePanelButton = "_77-k";
export var conversationContextContainer = "_77-l";
export var conversationDetailContainer = "_77-4";
export var detailWrapper = "_77-7";
export var dropdownButton = "_77-e";
export var dropdownTitle = "_77-9";
export var fullHeight = "_77-5";
export var hidden = "_77-a";
export var icon = "_77-b";
export var mergeSuggestionWrapper = "_77-m";
export var panel = "_77-i";
export var portalButtonsWrapper = "_77-c";
export var right = "_77-j";
export var tableSummaryContainer = "_77-8";
export var tableSummaryHeader = "_77-g";
export var threeDotsButton = "_77-f";
export var wide = "_77-h";